import { Storage } from "@faire/web/common/Storage";

// Used in Cypress code which is outside the module
export const IS_FOI_MODAL_E2E_FLAG = "IS_FOI_MODAL_E2E";

export const isFOIModalE2E = (): boolean => {
  return Storage.local.getItem(IS_FOI_MODAL_E2E_FLAG) === "true";
};
